var Color = require('color');

class ModalGallery {

    get template() {
        return `
        <div class="modal fade modal-gallery ${this.className || ''}" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body p-0" id="result">
                        <div class="row header-gallery">
                            <div class="col-12 ">
                                <a href="#" class="float-right close-btn" data-dismiss="modal"></a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col mg-0 modal-conantet"></div>
                        </div>
                        <div class="row footer align-items-center" style="display:none">
                            <div class="arrow"></div>
                            <div class="col-12 col-lg-9 description-container">
                                <p class="description" style="display:none"></p>
                            </div>
                            <div class="col-12 col-lg-3 controls text-center">
                                <a href="#" class="prev-btn"><img alt="${prevBtnText}" src="/images/gallery/controls/left.png"/></a>
                                <span class="current-item"></span>/<span class="total-items"></span>
                                <a href="#" class="next-btn"><img alt="${nextBtnText}" src="/images/gallery/controls/right.png"/></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    }

    constructor(args = {}) {
        this.filterItems = args.filterItems;
        this.className = args.className;

        if (args.renderDescription) {
            this.renderDescription = args.renderDescription;
        }
        if (args.checkVideo) {
            this.checkVideo = args.checkVideo;
        }

        this.data = args.data;

        // ✅ asegura API de YouTube lista (carga 1 sola vez y espera readiness)
        this.ytReady = this.ensureYouTubeAPI();

        this.$modal = $(this.template);
        $('body').append(this.$modal);
        this.initElements(args.element);
        this.initEvents();
    }

    /**
     * ✅ Carga la API IFrame de YouTube (una sola vez) y resuelve cuando YT.Player está disponible.
     */
    ensureYouTubeAPI() {
        // Ya está lista
        if (window.YT && window.YT.Player) return Promise.resolve();

        // Ya hay una promesa global en progreso
        if (window.__ytApiPromise) return window.__ytApiPromise;

        window.__ytApiPromise = new Promise((resolve) => {
            // YouTube ejecuta esto cuando termina de cargar la API
            const prev = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function () {
                try { if (typeof prev === 'function') prev(); } catch (e) {}
                resolve();
            };

            // Inyecta el script si no existe
            const exists = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
            if (!exists) {
                const tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                document.head.appendChild(tag);
            }
        });

        return window.__ytApiPromise;
    }

    setData(data) {
        this.data = data;
    }

    initElements(element) {
        this.$rootElement = $(element);
        this.$galleryConainer = this.$rootElement.find('.gallery-container');
        this.$dialogContent = this.$modal.find('.modal-conantet');
        this.$dialogFooter = this.$modal.find('.footer');
        this.$descritionP = this.$dialogFooter.find('.description');
        this.$btnClose = this.$modal.find('.close-btn');
        this.$controls = this.$dialogFooter.find('.controls');
        this.$window = $(window);
    }

    initEvents() {
        this.$modal
            .on('show.bs.modal', this.fixModal.bind(this))
            .on('shown.bs.modal', this.onShownModal.bind(this))
            .on('hide.bs.modal', this.onHideModal.bind(this))
            .on('click', 'a.prev-btn', this.onClickPrevBtn.bind(this))
            .on('click', 'a.next-btn', this.onClickNextBtn.bind(this))
            .on('click', 'div.video-btn', this.onClickVideoBtn.bind(this));

        this.$window.resize(this.onResizeWindow.bind(this));
    }

    getModalJQ() {
        return this.$modal;
    }

    fixModal(e) {
        this.$modal.animate({
            paddingRight: 0,
            paddingLeft: 0
        });

        if (this.$selectedItemDiv) {
            this.$selectedItemDiv.fadeIn('slow');
        }

        this.$btnClose.hide();
        setTimeout(() => {
            this.$btnClose.fadeIn('slow');
        }, 400);
    }

    onShownModal(e) {
        this.fixModalAfterShow.bind(this);
        this.$modal.find('.total-items').html(this.$dialogContentItems.length);
        this.$controls.css({
            visibility: this.$dialogContentItems.length > 1 ? 'visible' : 'hidden'
        });

        this.$modalGallery.slick({ arrows: false });
        this.initSlickEvents();
        this.$dialogFooter.fadeIn('slow');

        this.$modalGallery.slick('slickGoTo', this.selectedIndexItem, true);

        setTimeout(() => {
            this.playCurrentVideoIfNeeded();
        }, 400);
    }

    onHideModal() {
        this.$dialogFooter.hide();
        this.$btnClose.hide();
        this.restoreVerticalScroll();
        this.stopYTPlayer();
    }

    onClickPrevBtn(e) {
        e.preventDefault();
        this.pauseYtPlayer();
        this.restoreVerticalScroll();
        this.$modalGallery.slick('slickPrev');
    }

    onClickNextBtn(e) {
        e.preventDefault();
        this.pauseYtPlayer();
        this.restoreVerticalScroll();
        this.$modalGallery.slick('slickNext');
    }

    onClickVideoBtn() {
        let $currentItem = this.getCurrentItem();
        let ytPlayer = null;
        let $player = $currentItem.find('.player');
        let $videoBtn = $currentItem.find('.video-btn');

        this.fixVideoSize();
        $videoBtn.fadeOut(200);

        this.$modal.animate({ "scrollTop": "0px" }, 300);
        $player.fadeIn(500);

        ytPlayer = $currentItem.data('ytPlayer');
        this.hideVerticalScroll();

        if (ytPlayer) {
            ytPlayer.seekTo(0);
            ytPlayer.playVideo();
        } else {
            this.createYTPlayer($currentItem, $player, $videoBtn);
        }
    }

    fixModalAfterShow(e) {
        this.fixForTables();
        this.fixedFooter();
    }

    initVideoBtn(options, $div) {
        if (options.category == 'video') {
            let $divVideo = $(`
                <div class="player" style="display:none"><div class="div-player"></div></div>
                <div class="video-btn align-items-center">
                    <img src="/images/play.svg">
                </div>
            `);
            $div.prepend($divVideo);
            $div.addClass('item-video');
            $div.data('video', options.embed_code);
        }
    }

    renderItem(itemData) {
        const $div = $(`
            <div class="gallery-item" style="display:none">
                <p class="text-center"><img class="item-img" src="${itemData.image}" width="100%"/></p>
            </div>
        `);

        this.initVideoBtn(itemData, $div);
        return $div;
    }

    fetchCurrentIndex($element) {
        return $element.data('index');
    }

    show($elem) {
        if (this.filterItems) {
            this.options = this.filterItems($elem, this.data);
            this.$modalGallery = $('<div style="width:100%;">');
            this.selectedIndexItem = this.fetchCurrentIndex($elem);
            this.autoPlay = false;

            this.$dialogContentItems = this.options.map(itemData => this.renderItem(itemData));
            this.$dialogContent.empty().append(this.$modalGallery.append(this.$dialogContentItems));
            this.$modal.modal('show');
            this.checkVideo($elem, this);
        }
    }

    checkVideo($elem, modalGalleryInstance) {}

    shouldFixForFooder() {
        return this.$window.width() > 991 &&
            ((this.$dialogFooter.height() + this.$dialogContent.height()) > this.$window.height());
    }

    fixedFooter() {
        this.$dialogFooter.css('position', this.shouldFixForFooder() ? 'fixed' : 'absolute');
    }

    onResizeWindow() {
        if (this.$modalGallery) {
            this.fixVideoSize();
            this.fixModal();
            setTimeout(() => {
                this.fixModalAfterShow();
                this.fixForTables();
                this.fixedFooter();
            }, 100);
            this.$modalGallery.slick('setPosition');
        }
    }

    initSlickEvents() {
        this.$modalGallery
            .on('beforeChange', this.onSlickBeforeChange.bind(this))
            .on('afterChange', this.onSlickAfterChange.bind(this));
    }

    onSlickBeforeChange(e) {
        this.$descritionP.fadeOut('fast');
        this.pauseYtPlayer();
        this.restoreVerticalScroll();
    }

    renderDescription(currentData) {
        return currentData.description;
    }

    onSlickAfterChange(e, slick, currentSlide) {
        const $currentSlider = $(slick.$slides.get(currentSlide));
        const img = $currentSlider.find('img')[0];

        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height);

        const offset = this.$btnClose.offset();

        try {
            var pixelData = canvas.getContext('2d').getImageData(offset.left, 100, 1, 1).data;
            const color = Color.rgb(pixelData);
            if (color.isLight()) {
                this.$btnClose.addClass('force-btn-dark');
            } else {
                this.$btnClose.removeClass('force-btn-dark');
            }
        } catch (e) {}

        this.$modal.find('.current-item').html(currentSlide + 1);
        this.currentData = this.options[currentSlide];
        this.$descritionP.fadeIn().empty().append(this.renderDescription(this.currentData)).fadeIn();

        this.resumeYTPlayer();
        this.fixModalAfterShow();

        this.playCurrentVideoIfNeeded();
        this.autoPlay = false;
    }

    resumeYTPlayer() {
        let $currentItem = this.getCurrentItem();
        let ytPlayer = $currentItem.data('ytPlayer');
        if (ytPlayer && ytPlayer.playVideo && !$currentItem.find('.video-btn').is(":visible")) {
            ytPlayer.playVideo();
            this.hideVerticalScroll();
        }
    }

    getCurrentItem() {
        return this.$dialogContentItems[this.$modalGallery.slick('slickCurrentSlide')];
    }

    stopYTPlayer() {
        let $currentItem = this.getCurrentItem();
        let ytPlayer = $currentItem.data('ytPlayer');
        if (ytPlayer) ytPlayer.stopVideo();
    }

    pauseYtPlayer() {
        let $currentItem = this.getCurrentItem();
        let ytPlayer = $currentItem.data('ytPlayer');
        if (ytPlayer && ytPlayer.playVideo) ytPlayer.pauseVideo();
    }

    fixForTables() {
        if (this.shouldFixForTables()) {
            this.$controls.removeClass('col-lg-3').addClass('col-lg-12');
            this.$dialogFooter.height(this.$window.height() - this.$dialogContent.height());
        } else {
            this.resetHeightControls();
        }
    }

    resetHeightControls() {
        this.$controls.removeClass('col-lg-12').addClass('col-lg-3');
        this.$dialogFooter.css({ height: 'auto' })
    }

    shouldFixForTables() {
        return this.$window.width() > 992 &&
            this.$window.height() - this.$dialogContent.height() > 116;
    }

    restoreVerticalScroll() {
        this.$modal.css({ overflowY: 'auto' });
        this.$window.resize();
    }

    hideVerticalScroll() {
        this.$modal.css({ overflowY: 'hidden' });
        this.$modalGallery.slick('setPosition');
    }

    // ✅ ahora espera a que YT esté listo antes de crear el player
    createYTPlayer($currentItem, $player, $videoBtn) {
        let $divPlayer = $player.find('.div-player');

        this.ytReady.then(() => {
            let ytPlayer = new YT.Player($divPlayer[0], {
                videoId: $currentItem.data('video'),
                playerVars: {
                    rel: 0,
                    showinfo: 0,
                    ecver: 2
                },
                events: {
                    onReady: e => ytPlayer.playVideo(),
                    onStateChange: e => {
                        switch (e.data) {
                            case YT.PlayerState.ENDED:
                                $player.fadeOut();
                                $videoBtn.fadeIn();
                                break;
                        }
                    }
                }
            });

            $currentItem.data('ytPlayer', ytPlayer);
        });
    }

    fixVideoSize() {
        if (!this.$modalGallery) return;

        let $currentItem = this.getCurrentItem();
        let height;

        if (this.$window.width() < 992) {
            height = $currentItem.find('.item-img').height();
        } else {
            height = this.$window.height() - this.$dialogFooter.height();
        }

        let $player = $currentItem.find('.player');
        $player.height(height);

        let $divPlayer = $player.find('.div-player');
        $divPlayer.height(height);
    }

    playCurrentVideoIfNeeded() {
        const currentSlide = this.$modalGallery.slick('slickCurrentSlide');
        const currentData = this.options[currentSlide];

        if (!currentData || currentData.category !== 'video') return;

        const $currentItem = this.getCurrentItem();

        if (!$currentItem.find('.video-btn').is(':visible')) return;

        setTimeout(() => {
            this.onClickVideoBtn();
        }, 250);
    }
}

module.exports = ModalGallery;
